import { set } from 'lodash-es';

export default {
    updateAccountProperties(properties) {
        Object.keys(properties).forEach((path) => {
            set(this.currentForm, path, properties[path]);
        });
    },
    updateAccountBusinessHours(index, value) {
        Object.assign(this.currentForm.business_hours[index], value);
    },
    addAccountBusinessHoursException(businessHoursException) {
        this.currentForm.business_hours_exceptions.push({
            name: businessHoursException.name,
            closing_time: businessHoursException.closing_time,
            opening_time: businessHoursException.opening_time,
            date: businessHoursException.date,
            open: businessHoursException.open,
            division_id: businessHoursException.division_id,
        });
    },
    updateAccountBusinessHoursException(index, businessHoursException) {
        this.currentForm.business_hours_exceptions[index] = {
            name: businessHoursException.name,
            closing_time: businessHoursException.closing_time,
            opening_time: businessHoursException.opening_time,
            date: businessHoursException.date,
            open: businessHoursException.open,
            id: businessHoursException.id,
            deleted_at: businessHoursException.deleted_at,
            division_id: businessHoursException.division_id,
        };
    },
};
